/* knack-floating-gallery.js — random scatter + all-over drift + drag for the "Follow us" collage.
 *
 * Tiles are absolutely placed at random positions across the section, each drifting with its own
 * random velocity and bouncing off the edges, so they roam all over the band. Any tile can be
 * grabbed and thrown (Pointer Events) - it pauses, follows the pointer, then resumes drifting with
 * the throw velocity. A real drag suppresses the tile link. Under prefers-reduced-motion the tiles
 * are scattered statically (no drift), but stay draggable. Re-inits per section (Theme Editor safe).
 */
(function () {
  'use strict';

  var REDUCE = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function rand(min, max) {
    return Math.random() * (max - min) + min;
  }

  function initSection(section) {
    var stage = section.querySelector('.knack-floating__tiles');
    if (!stage) return;
    var tiles = [].slice.call(stage.querySelectorAll('.knack-floating__tile'));
    if (!tiles.length) return;

    var bounds = stage.getBoundingClientRect();
    var items = tiles.map(function (tile) {
      var w = tile.offsetWidth || 100;
      var h = tile.offsetHeight || 130;
      var it = {
        tile: tile, w: w, h: h,
        x: rand(0, Math.max(1, bounds.width - w)),
        y: rand(0, Math.max(1, bounds.height - h)),
        vx: REDUCE ? 0 : rand(-0.45, 0.45) || 0.3,
        vy: REDUCE ? 0 : rand(-0.4, 0.4) || 0.25,
        rot: rand(-13, 13),
        dragging: false, sx: 0, sy: 0, lastX: 0, lastY: 0, tvx: 0, tvy: 0, moved: false
      };
      draw(it);
      attachDrag(it);
      return it;
    });

    function draw(it) {
      it.tile.style.transform = 'translate3d(' + it.x + 'px,' + it.y + 'px,0) rotate(' + it.rot + 'deg)';
    }

    function attachDrag(it) {
      var t = it.tile;
      t.style.cursor = 'grab';
      t.style.touchAction = 'none';
      t.addEventListener('pointerdown', function (e) {
        it.dragging = true; it.moved = false;
        it.sx = e.clientX - it.x; it.sy = e.clientY - it.y;
        it.lastX = e.clientX; it.lastY = e.clientY;
        t.style.zIndex = '10'; t.style.cursor = 'grabbing';
        try { t.setPointerCapture(e.pointerId); } catch (err) {}
      });
      t.addEventListener('pointermove', function (e) {
        if (!it.dragging) return;
        it.x = e.clientX - it.sx; it.y = e.clientY - it.sy;
        it.tvx = e.clientX - it.lastX; it.tvy = e.clientY - it.lastY;
        it.lastX = e.clientX; it.lastY = e.clientY;
        if (Math.hypot(it.tvx, it.tvy) > 2) it.moved = true;
        draw(it);
      });
      function release(e) {
        if (!it.dragging) return;
        it.dragging = false; t.style.cursor = 'grab';
        try { t.releasePointerCapture(e.pointerId); } catch (err) {}
        if (!REDUCE) {
          it.vx = Math.max(-2.5, Math.min(2.5, it.tvx * 0.25)) || it.vx;
          it.vy = Math.max(-2.5, Math.min(2.5, it.tvy * 0.25)) || it.vy;
        }
      }
      t.addEventListener('pointerup', release);
      t.addEventListener('pointercancel', release);
      var link = t.querySelector('.knack-floating__link');
      if (link) link.addEventListener('click', function (e) { if (it.moved) e.preventDefault(); });
    }

    function tick() {
      var maxX, maxY;
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (it.dragging) continue;
        it.x += it.vx; it.y += it.vy;
        maxX = bounds.width - it.w; maxY = bounds.height - it.h;
        if (it.x <= 0) { it.x = 0; it.vx = Math.abs(it.vx); }
        else if (it.x >= maxX) { it.x = maxX; it.vx = -Math.abs(it.vx); }
        if (it.y <= 0) { it.y = 0; it.vy = Math.abs(it.vy); }
        else if (it.y >= maxY) { it.y = maxY; it.vy = -Math.abs(it.vy); }
        draw(it);
      }
      requestAnimationFrame(tick);
    }
    if (!REDUCE) requestAnimationFrame(tick);

    window.addEventListener('resize', function () {
      bounds = stage.getBoundingClientRect();
      items.forEach(function (it) {
        it.x = Math.min(it.x, Math.max(0, bounds.width - it.w));
        it.y = Math.min(it.y, Math.max(0, bounds.height - it.h));
        draw(it);
      });
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('.knack-floating').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
